import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import firebaseWebConfig from '../../firebase-web-config.json'

const firebaseConfig = firebaseWebConfig

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export default app

export const COLLECTIONS = {
  products: 'products',
  orders: 'orders',
  customers: 'customers',
  customerByEmail: 'customerByEmail',
  customerByPhone: 'customerByPhone',
  banners: 'banners',
  instagramReels: 'instagramReels',
  coupons: 'coupons',
  categories: 'categories',
  notes: 'notes',
  offlineSales: 'offlineSales',
  settings: 'settings',
  adminFcmTokens: 'adminFcmTokens',
  contactSubmissions: 'contactSubmissions',
  orderReturnRequests: 'orderReturnRequests',
  productReviews: 'productReviews',
  purchaseActivity: 'purchaseActivity',
} as const

export const isFirebaseConfigured = (): boolean =>
  Boolean(firebaseWebConfig.apiKey && firebaseWebConfig.projectId)

export const getAdminEmails = (): string[] => {
  const raw = import.meta.env.VITE_ADMIN_EMAILS || ''
  return raw
    .split(',')
    .map((e: string) => e.trim().toLowerCase())
    .filter(Boolean)
}
